export const EMPTY_PAGINATOR = {
  next_cursor: null,
  prev_cursor: null,
  per_page: 15,
}

export function normalizePaginator(p) {
  if (!p) return EMPTY_PAGINATOR
  return {
    next_cursor: p.next_cursor ?? null,
    prev_cursor: p.prev_cursor ?? null,
    per_page: Number(p.per_page ?? 15) || 15,
  }
}

export function safeT(t, key, fallback) {
  if (typeof t !== 'function') return fallback ?? key
  const translated = t(key)
  return translated && translated !== key ? translated : (fallback ?? key)
}

export function extractApiMessage(result) {
  const msg = result?.message ?? result?.error
  return typeof msg === 'string' && msg.trim() ? msg.trim() : ''
}

export function extractApiError(error) {
  const status = error?.status ?? error?.response?.status
  const data = error?.responseData ?? error?.response?.data ?? error?.data

  const backendMessage =
    data?.message ??
    data?.error?.message ??
    (typeof data?.error === 'string' ? data.error : undefined) ??
    (Array.isArray(data?.errors) ? data.errors.join(', ') : undefined) ??
    (typeof data === 'string' ? data : undefined)

  const fallbackMessage = error?.message

  const message =
    backendMessage ||
    (fallbackMessage && !/^Error\s\d+$/.test(fallbackMessage) ? fallbackMessage : undefined) ||
    fallbackMessage

  const code = typeof data?.error?.code === 'string' ? data.error.code : undefined

  return { status, code, backendMessage, fallbackMessage, message }
}
